import { render } from "./CustomAutocompleteVeterinarian.vue?vue&type=template&id=a8cfd192"
import script from "./CustomAutocompleteVeterinarian.vue?vue&type=script&lang=js"
export * from "./CustomAutocompleteVeterinarian.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__